import LibCopyToClipboardButton, {
  CopyToClipboardButtonProps,
} from '../../libs/frontend-lib/components/CopyToClipboardButton';
import { useTranslation } from '../../hooks/i18n';

export * from '../../libs/frontend-lib/components/CopyToClipboardButton';

const CopyToClipboardButton = (props: CopyToClipboardButtonProps) => {
  const { t } = useTranslation();
  return <LibCopyToClipboardButton copiedLabel={t('copiedToClipboard')} {...props} />;
};

export default CopyToClipboardButton;
